import Vue from 'vue'
import Router from 'vue-router'
import { auth, db } from '@/firebase';

import Preview from '@/views/Preview.vue'
import PreviewAll from '@/views/PreviewAll.vue'
import Report from '@/views/Report.vue'
import Login from '@/views/Login.vue'
import Settings from '@/views/Settings.vue'
import Admin from '@/views/Admin.vue'

import MarktimeEdit from '@/views/Marktime/Edit.vue'
import MarktimeNew from '@/views/Marktime/New.vue'
import MarktimeList from '@/views/Marktime/List.vue'

import VacationRequest from '@/views/Vacation/Request.vue'
import VacationList from '@/views/Vacation/List.vue'
import VacationPreview from '@/views/Vacation/Preview.vue'

import Users from '@/views/User/List.vue'
import User from '@/views/User/User.vue'

import Permissions from '@/views/Permissions.vue'
import Calendar from '@/views/Calendar.vue'

import TeamLeaderMarktimes from '@/views/TeamLeader/Marktimes.vue'
import TeamLeaderVacations from '@/views/TeamLeader/Vacations.vue'

import DashboardAccounter from '@/views/Dashboard/Accounter.vue'
import DashboardManager from '@/views/Dashboard/Manager.vue'
import DashboardVacations from '@/views/Dashboard/Vacations.vue'
import VacationsCalendar from '@/views/VacationsCalendar.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '*',
      redirect: '/'
    },{
      path: '/',
      name: 'home',
      component: Admin,
      redirect: 'marktime/list',
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'marktime/list',
          name: 'marktime-list',
          component: MarktimeList
        },
        {
          path: 'marktime/new',
          name: 'marktime-new',
          component: MarktimeNew
        },
        {
          path: 'marktime/edit/:id',
          name: 'marktime-edit',
          component: MarktimeEdit
        },

        {
          path: 'vacation/new',
          name: 'vacation-new',
          component: VacationRequest
        },
        {
          path: 'vacation/edit/:id',
          name: 'vacation-edit',
          component: VacationRequest
        },
        {
          path: 'vacation/list',
          name: 'vacation-list',
          component: VacationList
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: Calendar
        },

        {
          path: 'settings',
          name: 'settings',
          component: Settings
        },
        {
          path: 'dashboard/manager',
          name: 'dashboard-manager',
          component: DashboardManager,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().canViewManagerDashboard) return next()
                else next('home') 
              })
          }
        },
        {
          path: '/team-leader/marktimes',
          name: 'teamleader-marktimes',
          component: TeamLeaderMarktimes,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().role == 'rPHdxrt3Uatga4u9jx5T') return next()
                else next('home') 
              })
          }
        },
        {
          path: '/team-leader/vacations',
          name: 'teamleader-vacations',
          component: TeamLeaderVacations,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().role == 'rPHdxrt3Uatga4u9jx5T') return next()
                else next('home') 
              })
          }
        },
        {
          path: 'dashboard/accounter',
          name: 'dashboard-accounter',
          component: DashboardAccounter,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().canViewAccounterDashboard) return next()
                else next('home') 
              })
          }
        },
        ,
        {
          path: 'dashboard/vacations',
          name: 'dashboard-vacations',
          component: DashboardVacations,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().canViewVacations) return next()
                else next('home') 
              })
          }
        },
        {
          path: 'users',
          name: 'users',
          component: Users,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().canViewUsers) return next()
                else next('home') 
              })
          }
        },
        {
          path: 'permissions',
          name: 'permissions',
          component: Permissions,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().canViewPermissions) return next()
                else next('home') 
              })
          }
        },
        {
          path: 'user',
          name: 'user',
          component: User,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().canEditUsers) return next()
                else next('home') 
              })
          }
        },
        {
          path: 'user/:uid',
          name: 'user-edit',
          component: User,
          beforeEnter: (to, from, next) => {
            db 
              .collection('users')
              .doc(auth.currentUser.uid)
              .get()
              .then(doc => {
                // better handling role ID
                if (doc.data().role === 'superadmin' || doc.data().canEditUsers) return next()
                else next('home') 
              })
          }
        }
      ]
    },{
      path: '/login',
      name: 'login',
      component: Login
    },{
      path: '/marktime/preview/:id',
      name: 'preview',
      component: Preview,
      meta: {
        requiresAuth: true
      }
    },{
      path: '/vacation/preview/:id',
      name: 'vacation-preview',
      component: VacationPreview,
      meta: {
        requiresAuth: true
      }
    },{
      path: '/marktime/preview-all/:year/:month',
      name: 'preview-all',
      component: PreviewAll,
      meta: {
        requiresAuth: true
      }
    },{
      path: '/marktime/report/:year/:month',
      name: 'report',
      component: Report,
      meta: {
        requiresAuth: true
      }
    },{
      path: '/calendar/public',
      name: 'vacationsCalendar',
      component: VacationsCalendar,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) next('login')
  else if (requiresAuth && currentUser && currentUser.email === 'calendar@ezilly.nl' && to.name !== 'vacationsCalendar') {
    next('/calendar/public')
  }
  else if (to.name === 'vacationsCalendar' && !currentUser) next('login')
  else if (to.name === 'login' && currentUser) next('home')
  else next();
});

export default router;
